import { Inject, Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { WINDOW } from '@polaris-customerweb/sharedcomponents.core';
import {
    VehicleSubscription,
    VehicleSubscriptionService,
} from '@polaris-customerweb/sharedcomponents.vehicle-health';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionManagementService {
    constructor(
        @Inject(WINDOW) private window: Window,
        private configService: ConfigService,
        private vehicleSubscriptionService: VehicleSubscriptionService
    ) {}

    manageSubscription(
        vin: string,
        subscriptionId: string
    ): Observable<VehicleSubscription> {
        return this.vehicleSubscriptionService
            .getSubscription(vin)
            .pipe(
                tap((sub) =>
                    this.window.open(
                        `${this.configService.subscriptionManagementUrl}/${sub.isSubscriptionOwner ? subscriptionId : ''}`,
                        '_blank'
                    )
                )
            );
    }
}
